import {
  Package, Eye, Pause, Clock, CheckCircle, Scissors, Edit2, Truck,
  AlertCircle, XCircle, ClipboardList, ShoppingCart, FileText, Users,
  Ruler, Building2, Phone, Calendar, MapPin, Wallet,
} from 'lucide-react';

export const API = process.env.REACT_APP_BACKEND_URL;

export const STATUS_CONFIG = {
  NEW_ORDER: { label: 'New', color: 'bg-gray-100 text-gray-700', icon: Package },
  VERIFICATION_VISIT: { label: 'Verification & Visit', color: 'bg-orange-100 text-orange-700', icon: Eye },
  ON_HOLD: { label: 'On Hold', color: 'bg-amber-100 text-amber-700', icon: Pause },
  PENDING_APPROVAL: { label: 'Pending Approval', color: 'bg-yellow-100 text-yellow-700', icon: Clock },
  APPROVED: { label: 'Approved', color: 'bg-blue-100 text-blue-700', icon: CheckCircle },
  IN_PRODUCTION: { label: 'In Production', color: 'bg-purple-100 text-purple-700', icon: Scissors },
  FINAL_TOUCHES: { label: 'Final Touches', color: 'bg-indigo-100 text-indigo-700', icon: Edit2 },
  READY_FOR_DELIVERY: { label: 'Ready', color: 'bg-green-100 text-green-700', icon: Truck },
  DELIVERED: { label: 'Delivered', color: 'bg-emerald-100 text-emerald-700', icon: CheckCircle },
  ALTERATION: { label: 'Alteration', color: 'bg-red-100 text-red-700', icon: AlertCircle },
  CANCELLED: { label: 'Cancelled', color: 'bg-red-100 text-red-700', icon: XCircle },
};

export const KANBAN_COLUMNS = ['NEW_ORDER','VERIFICATION_VISIT','PENDING_APPROVAL','APPROVED','IN_PRODUCTION','FINAL_TOUCHES','READY_FOR_DELIVERY'];

export const DASHBOARD_STATUSES = ['NEW_ORDER','VERIFICATION_VISIT','ON_HOLD','PENDING_APPROVAL','APPROVED','IN_PRODUCTION','FINAL_TOUCHES','READY_FOR_DELIVERY','DELIVERED','ALTERATION','CANCELLED'];

export const TRANSITIONS = {
  NEW_ORDER: ['VERIFICATION_VISIT'],
  VERIFICATION_VISIT: ['PENDING_APPROVAL','ON_HOLD','CANCELLED'],
  ON_HOLD: ['PENDING_APPROVAL','CANCELLED'],
  PENDING_APPROVAL: ['APPROVED','CANCELLED'],
  APPROVED: ['IN_PRODUCTION'],
  IN_PRODUCTION: ['FINAL_TOUCHES'],
  FINAL_TOUCHES: ['READY_FOR_DELIVERY'],
  READY_FOR_DELIVERY: ['DELIVERED','APPROVED'],
  DELIVERED: ['APPROVED'],
};

export function getTabsForRole(role) {
  const t = {
    dashboard: { key:'dashboard', label:'Dashboard', icon:ClipboardList },
    kanban: { key:'kanban', label:'Kanban Board', icon:ShoppingCart },
    orders: { key:'orders', label:'Orders', icon:FileText },
    partial_paid: { key:'partial_paid', label:'Partial Paid', icon:Wallet },
    order_pool: { key:'order_pool', label:'Order Pool', icon:Package },
    employees: { key:'employees', label:'Employees', icon:Users },
    measurements: { key:'measurements', label:'Measurements', icon:Ruler },
    branches: { key:'branches', label:'Branches', icon:Building2 },
    callbacks: { key:'callbacks', label:'Callbacks', icon:Phone },
    consultations: { key:'consultations', label:'Consultations', icon:Calendar },
    pincodes: { key:'pincodes', label:'Pincodes', icon:MapPin },
    audit: { key:'audit', label:'Audit Log', icon:ClipboardList },
  };
  switch(role) {
    case 'SUPER_ADMIN': return [t.dashboard,t.kanban,t.orders,t.partial_paid,t.employees,t.measurements,t.branches,t.callbacks,t.consultations,t.pincodes,t.audit];
    case 'BRANCH_ADMIN': return [t.dashboard,t.kanban,t.orders,t.partial_paid,t.employees,t.measurements,t.callbacks,t.consultations,t.pincodes,t.audit];
    case 'PICKUP_AGENT':
    case 'SALES_AGENT': return [t.kanban,t.orders,t.measurements];
    case 'TAILOR': return [t.order_pool,t.kanban,t.measurements];
    default: return [t.kanban,t.orders];
  }
}

export function Section({ title, children }) {
  return (
    <div>
      <div className="flex items-center gap-2 mb-2">
        <div className="h-px flex-1 bg-border" />
        <span className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">{title}</span>
        <div className="h-px flex-1 bg-border" />
      </div>
      {children}
    </div>
  );
}
